var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCancel(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.15417 7.15417C7.80504 6.5033 8.86032 6.5033 9.51119 7.15417L19.9993 17.6423L30.4875 7.15417C31.1384 6.5033 32.1937 6.5033 32.8445 7.15417C33.4954 7.80504 33.4954 8.86032 32.8445 9.51119L22.3564 19.9993L32.8445 30.4875C33.4954 31.1384 33.4954 32.1937 32.8445 32.8445C32.1937 33.4954 31.1384 33.4954 30.4875 32.8445L19.9993 22.3564L9.51119 32.8445C8.86032 33.4954 7.80504 33.4954 7.15417 32.8445C6.5033 32.1937 6.5033 31.1384 7.15417 30.4875L17.6423 19.9993L7.15417 9.51119C6.5033 8.86032 6.5033 7.80504 7.15417 7.15417Z",
    fill: "#EB5757"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.713f67f93fba0a0922e1107653c11b7d.svg";
export { ForwardRef as ReactComponent };